var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`tag`, _vm.className || ``]},[_c('div',{staticClass:"text_label plusjakartasans-normal-cosmic-cobalt-12px"},[_vm._v(_vm._s(_vm.text5))])])
}
var staticRenderFns = []

export { render, staticRenderFns }